import { ReduxAction } from 'types/redux';
import { COURSES } from '../../constants/courses.constants';

export function courses(state: any = {}, action: ReduxAction) {
  switch (action.type) {
    case COURSES.GETALL_COURSES_REQUEST:
      return {
        loading: 'loading',
      };
    case COURSES.GETALL_COURSES_SUCCESS:
      return { ...state, courses: action.courses, loading: 'done' };
    case COURSES.GETALL_COURSES_FAILURE:
      return { ...state, courses: [], loading: 'done' };
    case COURSES.CREATE_MAIN_COURSES_SUCCESS:
      return {
        ...state,
        coursesMain: action.courses,
      };
    case COURSES.CREATE_COURSES_SUCCESS:
      return {
        ...state,
        coursesCreate: action.courses,
        coursesDetail: { ...state.coursesDetail, ...(action.courses as Record<string, unknown>) },
      };
    case COURSES.GET_COURSES_DETAIL_SUCCESS:
      return { ...state, coursesDetail: action.courses };
    case COURSES.CREATE_COURSES_FAILURE:
      return {
        error: action.error,
      };
    case COURSES.DELETE_COURSES_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: [state.items].map((course: any) =>
          course.id === action.id ? { ...course, deleting: true } : course
        ),
      };
    case COURSES.DELETE_COURSES_SUCCESS:
      // remove deleted user from state
      return {
        items: [state.items ?? []].filter(
          (course: any) => course.id !== action.id
        ),
      };
    case COURSES.DELETE_COURSES_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user
      return {
        ...state,
        items: state.items.map((course: any) => {
          if (course.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...courseCopy } = course;
            // return copy of user with 'deleteError:[error]' property
            return { ...courseCopy, deleteError: action.error };
          }

          return course;
        }),
      };
    default:
      return state;
  }
}
